import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";


// components
import AybMenuForm from "./_form";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {LB_ACTIONS, LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services

// utils
import {getStateByPath} from "../../../redux/selectors";
import {GenericButton} from "../../../components/buttons/customButtons";
import {aybMenuService} from "../../../jwt/_services/ayb/aybMenuService";
import AybMenuFilters from "./_filters";
import {confirmAlert} from "react-confirm-alert";
import {ConfirmPriceExchange} from "../../../components/confirmAlertForms/ConfirmPriceExchange";

const AybMenuList = (props) => {
    const path = props?.path ;
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, udn, category, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    useEffect( () => {
        if( !app.id || !udn.id || filter  )
            return

        props.setFilter(path, {
            onlyRegistered: true,
            fbDataBase : { id : app?.fbDataBase?.id },
            item :  {
                category : category,
                udn : { id : udn.id }
            }
        })
    }, [ app, udn, category ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, aybMenuService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(AybMenuForm, { path, data, closeOnEscape:false,
            closeOnClickOutside: false})
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(AybMenuForm, { path })
    }

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: aybMenuService,
        remove : genericIndexedActions.delete,
    } );

    const confirmAssignPrice = _ => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside:true,
        customUI: ({onClose}) => <ConfirmPriceExchange udn={udn} category={category} fbDataBaseId={app?.fbDataBase?.id} onClose={onClose}/>
    });

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'uid',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'title',
            text: 'Titulo'
        }, {
            dataField: 'placeName',
            text: 'Lugar',
            headerStyle: {width: '150px'},
        }, {
            dataField: 'status',
            text: "Activo",
            headerStyle: {width: '30px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
            formatter: (cell, row) => <>
                <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <TranslateButton item={row} service={aybMenuService} path={path} askForConfirmation={false} />
                <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>
        }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                {
                    (category === 'XPA' || category === 'HCDP_SPA') ?
                        <GenericButton
                            style={'warning-secondary'}
                            label={'Actualizar precios'}
                            toolTip={'Elige el tipo de cambio para actualizar los precios'}
                            icon={'fa-sync'}
                            permission={'edit'}
                            onClick={confirmAssignPrice}
                        /> : null
                }
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <AybMenuFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = _ => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(AybMenuList);